import styled, {css} from 'styled-components'
import { deviceMin, deviceMax } from '../../theme/breakpoints'

export const h1style = css`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH1.laptop};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH1};

  @media ${deviceMax.laptop} {
    font-size: ${({ theme }) => theme.fonts.sizes.titleH2.laptop};
    line-height: ${({ theme }) => theme.fonts.lineHeight.titleH2};
  }
`

export const h2style = css`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH2.base};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH2};

  @media ${deviceMin.laptop} {
    font-size: ${({ theme }) => theme.fonts.sizes.titleH2.laptop};
  }
`

export const h3style = css`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3.base};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};

  @media ${deviceMin.laptop} {
    font-size: ${({ theme }) => theme.fonts.sizes.titleH3.laptop};
  }
`

export const h4style = css`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH4.laptop};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH4};
`

export const h5style = css`
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
`

export const h6style = css`
   font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`

export const StyledH1 = styled.h1`
  ${h1style}
`

export const StyledH2 = styled.h2`
  ${h2style}
`

export const StyledH3 = styled.h3`
  ${h3style}
`

export const StyledH4 = styled.h4`
  ${h4style}
`

export const StyledH5 = styled.h5`
  ${h5style}
`

export const StyledH6 = styled.h6`
  ${h6style}
`
